// extracted by mini-css-extract-plugin
export default {"graphWrapper":"styles_graph-wrapper__v4KSC"};